<script>
    import { faSliders, faXmark } from "@fortawesome/free-solid-svg-icons";
    import Fa from "svelte-fa";
    import { authenticated, admin, user, subscription, previouslyLoggedIn } from "../../firebase/auth";
    import { menu } from "../../stores";
    import Navbar from "../navbar/Navbar.svelte";
    import Sidebar from "../navigation/sidebar/Sidebar.svelte";
    import Button from "../ui/Button.svelte";
    import Login from "./Login.svelte";
    import SignUp from "./SignUp.svelte";

    $: simulatedAdmin = $admin;
    let showViewSettings = false;

    let input = {
        email: "",
        password: "",
        passwordControl: ""
    }
</script>

{#if $authenticated == undefined}
    <!-- Users credentials are still being checked with the server, lets just wait... -->
{:else if $authenticated == false}
    <!-- User is not authenticated. They are either not logged in, or don't have an account yet... -->
    {#if $previouslyLoggedIn}
        <Login bind:input switchToSignUp={() => {$previouslyLoggedIn = !$previouslyLoggedIn}}/>
    <!-- {:else}
        <SignUp bind:input switchToLogin={() => {$previouslyLoggedIn = !$previouslyLoggedIn}}/> -->
    {/if}
{:else if $authenticated == true}
    {#if $subscription === undefined}
        <!-- Users roles and subscriptions are still being checked with the server, lets just wait... -->
    {:else}
        <!-- User is logged in, let's show them what they are allowed to see... -->
        <div class="layout">
            <Sidebar />
            <main>
                <div class="content">
                    {#if simulatedAdmin && $$slots.admin}
                        <slot name="admin" />
                    {:else if simulatedAdmin && $$slots.sub || $subscription != false && $$slots.sub}
                        <slot name="sub" />
                    {:else if $$slots.free}
                        <slot name="free"/>
                    {:else if $$slots.sub}
                        <h1>Upgrade nötig</h1>
                        <p>Um auf diese Seite zuzugreifen musst du eine Subscription haben</p>
                    {:else if $$slots.admin}
                        <h1>Adminrechte nötig</h1>
                        <p>Du solltest hier nicht sein</p>
                    {/if}
                </div>
            </main>
        </div>
    {/if}
{/if}


<!-- THIS IS JUST TO SIMULATE THE DIFFERENT CASES AS ADMIN -->
{#if $admin}
    <div class="view-settings">
        {#if showViewSettings}
            <label>Eingeloggt
                <select bind:value={$authenticated}>
                    <option value={undefined}>undefined</option>
                    <option value={true}>Ja</option>
                    <option value={false}>Nein</option>
                </select>
            </label>
            <label>Admin
                <input type=checkbox bind:checked={simulatedAdmin}>
            </label>
            <label>Subscription
                <select bind:value={$subscription}>
                    <option value={false}>Keine</option>
                    <option value="basic">Basic</option>
                    <option value="premium">Premium</option>
                </select>
            </label>
        {/if}
        <Button on:click={() => {showViewSettings = !showViewSettings}}>
            <Fa
                slot="icon"
                icon={showViewSettings?faXmark:faSliders}
            />
        </Button>
    </div>
{/if}

<style>
    .layout {
        display: flex;
        width: 100%;
        height: 100vh;
    }

    main {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        position: relative;
    }
    
    .content {
        max-width: 42rem;
        width: calc(100% - 2rem);
        box-sizing: border-box;
        margin: 0 max(calc((100% - 42rem) / 2), 1rem);
        position: relative;
        /* padding: 1rem; */
    }

    .view-settings {
        position: fixed;
        z-index: 100;
        bottom: 0.5rem;
        right: 0.5rem;
        display: flex;
        gap: 2rem;
        align-items: center;
    }

    .view-settings label {
        display: inline-block;
    }

    select {
        margin: 0;
    }
</style>

